import { IGoodsDetail } from '@/api/types/public';

// 毫米转英寸的常量
const MM_TO_IN = 0.03937;

export interface FrameSize {
  frame_total_length: string | number;
  frame_bridge: string | number;
  glass_width: string | number;
  glass_height: string | number;
  frame_leg_length: string | number;
  frame_stipule_length: string | number;
}

export const useFrameSize = (detail: IGoodsDetail['product'], inches?: boolean): FrameSize => {
  const size = {
    frame_total_length: 0,
    frame_bridge: 0,
    glass_width: 0,
    glass_height: 0,
    frame_leg_length: 0,
    frame_stipule_length: 0,
  };

  if (detail) {
    Object.keys(size).forEach((key) => {
      if (inches) {
        // @ts-ignore - 忽略类型检查
        size[key] = detail[key] ? (detail[key] * MM_TO_IN).toFixed(2) : 0;
      } else {
        // @ts-ignore - 忽略类型检查
        size[key] = detail[key] || 0;
      }
    });
  }

  return size;
};
